import { Switch } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import React from 'react';
import { Controller, UseControllerProps } from 'react-hook-form';

// TODO: We lose type saftey here but not sure how else to handle this
// Fix once figured out
interface ControlledSwitchProps extends UseControllerProps<any, any> {
  label: string;
  disabled?: boolean;
  helperText?: string;
}

const ControlledSwitch = ({ label, disabled, helperText, ...controllerProps }: ControlledSwitchProps) => {
  return (
    <>
      <FormControlLabel
        control={
          <Controller
            {...controllerProps}
            render={({ field }) => (
              <Switch
                {...field}
                disabled={disabled}
                onChange={(e) => field.onChange(e.target.checked)}
                checked={field.value}
              />
            )}
          />
        }
        label={label}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </>
  );
};

export default ControlledSwitch;
